import { observable } from 'mobx';

export interface TravelerShinkansenTypeArgs {
  id?: number;
  travelerInformationId?: number;
  idx?: number;
  shinkansenType?: string;
  shinkansenSeatType?: string;
  shinkansenSeat?: string;
  shinkansenTicketType?: string;
}

export interface TravelerShinkansenTypeResponseArgs {
  id: number;
  traveler_information_id: number;
  idx: number;
  shinkansen_type?: string;
  shinkansen_seat_type?: string;
  shinkansen_seat?: string;
  shinkansen_ticket_type?: string;
}

export const convertTravelerShinkansenTypeResponseToArgs = (
  response: TravelerShinkansenTypeResponseArgs
): TravelerShinkansenTypeArgs => {
  return {
    id: response.id,
    travelerInformationId: response.traveler_information_id,
    idx: response.idx,
    shinkansenType: response.shinkansen_type ?? '',
    shinkansenSeatType: response.shinkansen_seat_type ?? '',
    shinkansenSeat: response.shinkansen_seat ?? '',
    shinkansenTicketType: response.shinkansen_ticket_type ?? ''
  };
};

class TravelerShinkansenType {
  @observable id: number | null;
  @observable travelerInformationId: number | null = null;
  @observable idx: number;
  @observable shinkansenType: string;
  @observable shinkansenSeatType: string;
  @observable shinkansenSeat: string;
  @observable shinkansenTicketType: string;

  constructor(args: TravelerShinkansenTypeArgs) {
    this.id = args.id ?? null;
    this.travelerInformationId = args.travelerInformationId ?? null;
    this.idx = args.idx ?? 0;
    this.shinkansenType = args.shinkansenType ?? '';
    this.shinkansenSeatType = args.shinkansenSeatType ?? '';
    this.shinkansenSeat = args.shinkansenSeat ?? '';
    this.shinkansenTicketType = args.shinkansenTicketType ?? '';
  }

  updateParams() {
    return {
      id: this.id,
      traveler_information_id: this.travelerInformationId,
      shinkansen_type: this.shinkansenType,
      shinkansen_seat_type: this.shinkansenSeatType,
      shinkansen_seat: this.shinkansenSeat,
      shinkansen_ticket_type: this.shinkansenTicketType
    };
  }

  getShinkansenTicketTypeText() {
    switch (this.shinkansenTicketType) {
      case 'normal':
        return '通常きっぷ';
      case 'kyuusyuu':
        return 'JR九州きっぷ';
      case 'bulk_ticket':
        return '回数券';
      case 'ex':
        return 'EX-IC';
      default:
        return '';
    }
  }

  getShinkansenSeatTypeText() {
    switch (this.shinkansenSeatType) {
      case 'reserve':
        return '指定席';
      case 'free':
      case 'non_reserved':
        return '自由席';
      case 'green':
        return 'グリーン席';
      default:
        return '';
    }
  }
}

export default TravelerShinkansenType;
